import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockId, setAttributes } ) {
	const unique = blockId
		? `.alpha-hero-block-${ blockId }`
		: '.wp-block-alphablock-hero';
	const {
		padding,
		minHeight,
		alignment,
		backgroundColor,
		containerBorder,
		containerBorderRadius,
		margin,
	} = attributes;

	let CssObj = {
		[ unique ]: [
			GenerateCss.border( containerBorder ),
			GenerateCss.borderRadius( containerBorderRadius ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
			GenerateCss.css( 'text-align', alignment ),
			GenerateCss.background( {
				enableBackground: true,
				backgroundType: 'color-gradient',
				backgroundColor: backgroundColor,
				backgroundImage: null,
			} ),
		],
		[ `${ unique } .alpha-column-blocks` ]: [
			GenerateCss.lengthProp( 'min-height', minHeight ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
